<template>
    <div class="products">
        <banner :bannerObj="banner"/>
        <div class="container">
            <div class="products_content content">
                <headline :titleObj="ownedProductsTitle"></headline>
                <div class='flex-container products_flex-container'>
                    <panel
                        v-for="item in productOwned"
                        :key="item.content"
                        :panelObj="item">
                    </panel>
                </div>
            </div>

            <div class="products_content products_content-government content">
                <headline :titleObj="governmentProductsTitle"></headline>
                <div class='flex-container products_flex-container'>
                    <panel
                        v-for="item in productGovernment"
                        :key="item.content"
                        :panelObj="item">
                    </panel>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Banner from '@/components/Banner.vue'
    import Headline from '@/components/Headline.vue'
    import Panel from '@/components/products/panel.vue'

    export default {
        name: 'Products',
        components: {
            'banner': Banner,
            'headline': Headline,
            'panel': Panel
        },
        data() {
            return {
                productOwned: [{
                    'title': '風狂B近',
                    'content': 'tt',
                    'image': new URL('../assets/images/product_TT_m.jpg', import.meta.url).href,
                    'link': 'https://typhoon.tw/'
                },{
                    'title': '釣魚天氣地圖',
                    'content': 'fwm',
                    'mobile': true,
                    'image': new URL('../assets/images/product_FWM_m.jpg', import.meta.url).href,
                    'link': 'https://www.facebook.com/FishingWeatherMap'
                },{
                    'title': '口袋陸龜',
                    'content': 'tortoise',
                    'mobile': true,
                    'image': new URL('../assets/images/product_PocketTortoise_m.gif', import.meta.url).href,
                    'link': '/game-intro'
                }],
                productGovernment: [{
                    'title': '熱帶氣旋偵測系統',
                    'content': 'tcf',
                    'image': new URL('../assets/images/product_TCF_m.jpg', import.meta.url).href,
                    'link': 'https://tctracker.cwb.gov.tw/'
                },{
                    'title': '颱風預報警報作業整合',
                    'content': 'tafis2',
                    'image': new URL('../assets/images/product_TAFIS_m.jpg', import.meta.url).href,
                    'link': ''
                }, {
                    'title': '水利署河川局防汛系統',
                    'content': 'frims',
                    'image': new URL('../assets/images/product_FRIMS_m.jpg', import.meta.url).href,
                    'link': ''
                },{
                    'title': '電力氣象資訊展示',
                    'content': 'taipower',
                    'image': new URL('../assets/images/product_TPW_m.jpg', import.meta.url).href,
                    'link': ''
                },{
                    'title': '空氣品質多模式預報平台',
                    'content': 'epa',
                    'image': new URL('../assets/images/product_EPA_m.jpg', import.meta.url).href,
                    'link': ''
                },{
                    'title': '農園觀天氣',
                    'content': 'bmtw',
                    'mobile': true,
                    'image': new URL('../assets/images/product_BMTW_m.jpg', import.meta.url).href,
                    'link': ''
                },{
                    'title': 'Talent Taiwan',
                    'content': 'Talent Taiwan',
                    'mobile': true,
                    'image': new URL('../assets/images/product_Talent-Taiwan.png', import.meta.url).href,
                    'link': 'https://talent.nat.gov.tw/?lang=zh',
                }],
                ownedProductsTitle: {en: 'OUR PRODUCTS', ch: '自研產品'},
                governmentProductsTitle: {en: 'CASE STUDIES', ch: '合作案例'},
                banner: {
                    title: '開發成果',
                    info: '透過實際開發的案件展示與使用，來更加了解我們可以<br/>帶給您的服務與合作機會。',
                    img: new URL('../assets/images/2x/products@2x.png', import.meta.url).href
                }
            }
        }
    }
</script>
